import * as React from 'react'

import { Box, Icon, IconBadge } from '@factorialco/deprecated-design-system'
import isNil from 'lodash/isNil'

import { observer } from 'mobx-react'

import UserAvatar from 'modules/core/components/UserAvatar'
import users from 'modules/core/store/collections/users'

import type { InboxRequest } from 'modules/notifications/hooks/useNotificationsRequests'

type BadgeProps = {
  request: InboxRequest
  icon?: React.ComponentProps<typeof Icon.Medium>['icon']
}

export const Badge = observer(({ request, icon }: BadgeProps) => {
  const accessId = request.avatarAccessIdentifier
  const user = users.find({ id: accessId })

  return (
    <Box>
      {isNil(user) ? (
        <IconBadge
          color="viridian200"
          iconColor="viridian1200"
          size="s32"
          icon={
            (icon || request.icon || 'calendar') as React.ComponentProps<typeof Icon.Medium>['icon']
          }
        />
      ) : (
        <UserAvatar user={user} size="s32" />
      )}
    </Box>
  )
})
